import { render, staticRenderFns } from "./dateFilter.vue?vue&type=template&id=380271d0&"
import script from "./dateFilter.vue?vue&type=script&lang=ts&"
export * from "./dateFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports